import { EXPRESSION_TYPES } from '@willow/types-iso';

import { formatCurrency as formatCurrencyUtil } from '../../../utils/formatCurrency';
import { functionFrom, FunctionLibrary, getFunctionSignature, spreadParam } from '../FunctionDefinition';

const concat = functionFrom(
  'concat',
  spreadParam({ name: 'str', type: EXPRESSION_TYPES.string }),
  EXPRESSION_TYPES.string,
  (_ctx, ...strs) => strs.join(''),
  'Concatenates any number of strings into a single string.',
);

const formatCurrency = functionFrom(
  'formatCurrency',
  [{ name: 'amount', type: EXPRESSION_TYPES.number }] as const,
  EXPRESSION_TYPES.string,
  (_ctx, amount) => formatCurrencyUtil(amount),
  'Formats a number as a USD currency string (e.g. 1234.5 -> "$1,234.50").',
);

export const STRING_FUNCTIONS = {
  [getFunctionSignature(concat)]: concat,
  [getFunctionSignature(formatCurrency)]: formatCurrency,
} satisfies FunctionLibrary;
